// App
export const SET_ERROR = "SET_ERROR";
export const SET_IS_FIREBASE_AUTHENTICATED = "SET_IS_FIREBASE_AUTHENTICATED";
export const SET_IS_AUTHENTICATED = "SET_IS_AUTHENTICATED";
export const SET_ROUTER_STATE = "SET_ROUTER_STATE";
export const SET_SESSION_PREFERENCES = "SET_SESSION_PREFERENCES";
export const SET_USER = "SET_USER";
export const SET_USER_METADATA = "SET_USER_METADATA";
export const SET_USER_METADATA_FETCHED = "SET_USER_METADATA_FETCHED";
export const START_ASYNC_ACTION = "START_ASYNC_ACTION";
export const STOP_ASYNC_ACTION = "STOP_ASYNC_ACTION";
export const USER_LOGOUT = "USER_LOGOUT";
export const SET_SCREEN_SIZE = "SET_SCREEN_SIZE";

// Advanced search
export const SET_ADVANCED_SEARCH_FIELDS = "SET_ADVANCED_SEARCH_FIELDS";
export const SET_ADVANCED_SEARCH_PERIODS = "SET_ADVANCED_SEARCH_PERIODS";
export const SET_ADVANCED_SEARCH_RESULTS = "SET_ADVANCED_SEARCH_RESULTS";

// Bills of Lading
export const SET_BILLS_OF_LADING = "SET_BILLS_OF_LADING";
export const SET_SHIPMENT_ROUTE = "SET_SHIPMENT_ROUTE";

// Customers
export const SET_CUSTOMER = "SET_CUSTOMER";
export const SET_CUSTOMERS = "SET_CUSTOMERS";

// Documents
export const SET_DOCUMENTS = "SET_DOCUMENTS";

// Loads
export const SET_LOADS = "SET_LOADS";

// Mill Orders
export const SET_MILL_ORDERS = "SET_MILL_ORDERS";

// Notifications
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const SET_NOTIFICATION = "SET_NOTIFICATION";
export const SET_PUBLISH_SUCCEEDED = "SET_PUBLISH_SUCCEEDED";

// Ordered Products
export const SET_ORDERED_PRODUCTS = "SET_ORDERED_PRODUCTS";

// Pre Planning
export const SET_PREPLANNING = "SET_PREPLANNING";

// Purchase Orders
export const SET_PURCHASE_ORDERS = "SET_PURCHASE_ORDERS";
export const SET_PURCHASE_ORDER = "SET_PURCHASE_ORDER";
export const SET_PURCHASE_ORDER_REPRESENTATIVES = "SET_PURCHASE_ORDER_REPRESENTATIVES";

// Unit of Measurement
export const SET_UNITOFMEASUREMENTS = "SET_UNITOFMEASUREMENTS";

export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

// Contact us
export const SET_CONTACT_US_SEND_SUCCEEDED = "SET_CONTACT_US_SEND_SUCCEEDED";
export const SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED = "SET_REPORT_THIS_ISSUE_SEND_SUCCEEDED";



// WEBPACK FOOTER //
// ./src/actions/types.js